// Vue
import Vue from "vue";

Vue.config.productionTip = false;

// Mixins
import {constantsMixin} from "@/mixins/constantsMixin.js";

Vue.mixin(constantsMixin);

// Local storage
import VueLocalStorage from "vue-localstorage";

Vue.use(VueLocalStorage);

// Router
import router from "@/router";

// Bootstrap
import {
    BootstrapVue,
    CardPlugin,
    DropdownPlugin,
    IconsPlugin,
    LayoutPlugin,
    ModalPlugin,
    TablePlugin,
    VBScrollspyPlugin,
} from "bootstrap-vue";

Vue.use(BootstrapVue);
Vue.use(CardPlugin);
Vue.use(DropdownPlugin);
Vue.use(IconsPlugin);
Vue.use(LayoutPlugin);
Vue.use(ModalPlugin);
Vue.use(TablePlugin);
Vue.use(VBScrollspyPlugin);

// OverlayScrollbars
import "overlayscrollbars/styles/overlayscrollbars.css";

// Leaflet styles
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

// App
import App from "@/App";

export const app = new Vue({
    router,
    render: (h) => h(App),
}).$mount("#app");
